import { NavLink, Link } from "react-router-dom";
import type { PanelMenuItem } from "@/data/panels";
import { useAuth } from "@/hooks/useAuth";
import { resolvePanelUser } from "@/lib/profile";
import {useSiteSettingsContext} from "@/hooks/useSiteSettingsContext";

interface RoleSidebarProps {
  menu: PanelMenuItem[];
  homePath: string;
  roleLabel: string;
}

export default function RoleSidebar({
  menu,
  homePath,
  roleLabel,
}: RoleSidebarProps) {
  const { user } = useAuth();
  const identity = resolvePanelUser(user);
  const { settings } = useSiteSettingsContext();
  const name = settings.siteName || "Dersdinle";
  return (
    <aside
      id="panel-sidebar"
      className="hidden lg:flex fixed top-0 left-0 bottom-0 w-[260px] bg-primary-950 z-40 flex-col"
    >
      {/* Logo */}
      <Link
        to="/"
        className="flex items-center gap-2.5 h-16 px-5 border-b border-white/10 shrink-0"
        aria-label={`${name} ana sayfa`}
      >
        <img
          src="https://static.readdy.ai/image/aaba9897d2facfbc7f1204630a4017ac/701ba01ffa472e24f05c5cced92a417f.png"
          alt={name}
          className="h-9 w-auto object-contain"
        />
      </Link>

      {/* Rol etiketi */}
      <div className="px-5 pt-4 pb-2">
        <span className="inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider text-accent-300">
          <i className="ri-verified-badge-line text-xs" aria-hidden="true"></i>
          {roleLabel} paneli
        </span>
      </div>

      {/* Navigasyon */}
      <nav className="flex-1 overflow-y-auto px-3 py-2" aria-label={`${roleLabel} paneli menüsü`}>
        {menu.map((item) => (
          <NavLink
            key={item.href}
            to={item.href}
            end={item.href === homePath}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-medium mb-0.5 transition-colors ${
                isActive
                  ? "bg-accent-500 text-primary-950"
                  : "text-white/70 hover:bg-white/10 hover:text-white"
              }`
            }
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className={`${item.icon} text-base`} aria-hidden="true"></i>
            </span>
            {item.label}
          </NavLink>
        ))}
      </nav>

      {/* Kullanıcı kimliği */}
      <div className="border-t border-white/10 p-4 shrink-0">
        <div className="flex items-center gap-3">
          <span className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 text-accent-300 font-heading font-semibold text-sm">
            {identity.initials || "K"}
          </span>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-white truncate">
              {identity.name || "Kullanıcı"}
            </p>
            <p className="text-xs text-white/50 truncate">{identity.email}</p>
          </div>
        </div>
      </div>
    </aside>
  );
}